import { GlobalEventDispatcher } from './globalEventDispatcher';

export function getAngebotsIds(): { angebotsId: string; appId: string }[] {
  const availableStores = GlobalEventDispatcher.getInstance().stores;
  return availableStores.map(filteredStore => ({
    appId: filteredStore.appName,
    angebotsId: filteredStore.angebotsId,
  }));
}
